import { trpc } from "@/lib/trpc/react";

/**
 * Hook for fetching social interactions (friends attending) for a list of shows
 * Only fetches when enabled and showIds are provided
 *
 * @param showIds - Array of show IDs to check for friend attendance
 * @param enabled - Whether to enable the query (typically tied to filter state)
 * @returns Query result with data as Record<showId, friendCount>
 *
 * @example
 * ```tsx
 * const { data, isLoading } = useShowSocialInteractionsList(
 *   ['show-1', 'show-2'],
 *   isFilterActive
 * );
 * // data: { 'show-1': 3, 'show-2': 1 }
 * ```
 */
export function useShowSocialInteractionsList(
	showIds: string[],
	enabled: boolean,
): ReturnType<typeof trpc.show.getSocialInteractionsForList.useQuery> {
	return trpc.show.getSocialInteractionsForList.useQuery(
		{ showIds },
		{
			enabled: enabled && showIds.length > 0,
			staleTime: 30 * 1000, // 30s (matches DYNAMIC tier)
			gcTime: 10 * 60 * 1000, // 10min (matches DYNAMIC tier)
		},
	);
}
